import { render, staticRenderFns } from "./EditDegree.vue?vue&type=template&id=4ad0a4ca&scoped=true&"
import script from "./EditDegree.vue?vue&type=script&lang=js&"
export * from "./EditDegree.vue?vue&type=script&lang=js&"
import style0 from "./EditDegree.vue?vue&type=style&index=0&id=4ad0a4ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad0a4ca",
  null
  
)

export default component.exports